module.exports = __webpack_public_path__ + "img/end.93274b81.gif";